import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MarkdownWrapper from "@/components/markdownWrapper";
import MediaWrapper from "@/components/mediaWrapper";

/*
  This component requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/typography'),
    ],
  }
  ```
*/

export const query = graphql`
  fragment ContentSplitWithImageData on StrapiComponentContentSplitWithImage {
    title
    topic
    description
    image {
      ...StrapiMediaSubquery
    }
    body {
      ...StrapiSharedBody
    }
  }
`;

function SplitWithImage({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="relative bg-background-white">
      <div className="lg:absolute lg:inset-0">
        <div className="lg:absolute lg:inset-y-0 lg:left-0 lg:w-1/2">
          {data.image && (
            <MediaWrapper
              media={data.image}
              divClassName="h-56 w-full lg:absolute lg:h-full"
            />
          )}
        </div>
      </div>
      <div className="relative px-4 pb-16 pt-12 sm:px-6 sm:pt-16 lg:mx-auto lg:grid lg:max-w-7xl lg:grid-cols-2 lg:px-8">
        <div className="lg:col-start-2 lg:pl-8">
          <div className="mx-auto max-w-prose text-base lg:ml-auto lg:mr-0 lg:max-w-lg">
            {data.topic && (
              <h4 className="font-semibold uppercase leading-6 tracking-wide text-text-secondary">
                <MarkdownWrapper text={data.topic} />
              </h4>
            )}
            {data.title && (
              <h3 className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-text-primary sm:text-4xl">
                <MarkdownWrapper text={data.title} />
              </h3>
            )}
            {data.description && (
              <MarkdownWrapper
                text={data.description}
                markdownClassName="mt-8 text-lg text-text-secondary"
                replaceParagraph={false}
              />
            )}
            {data.body && data.body.text && (
              <div className="prose-prose-primary prose mt-5 text-text-secondary">
                <MarkdownWrapper
                  text={data.body.text}
                  images={data.body.images}
                  imgDivClassName="w-full"
                  imgClassName="rounded-lg"
                  width={1310}
                  height={873}
                  replaceParagraph={false}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

SplitWithImage.propTypes = {
  data: PropTypes.object,
};

export default SplitWithImage;
